// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"1317":"Paginator-Paginator","2999":"Ipid-Ipid","5795":"Priips-Priips","6438":"StarRating-StarRating","7305":"Paginator"}[chunkId] + "." + {"1317":"7f0ca9f2df43b12e2638","2999":"7f0ca9f2df43b12e2638","5795":"7f0ca9f2df43b12e2638","6438":"086ed3073b9de1395cf0","7305":"7f0ca9f2df43b12e2638"}[chunkId] + ".css";
};